import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import ErrorBoundary from "@/components/ErrorBoundary";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import MapWorkspace from "@/pages/MapWorkspace";
import CountyDetail from "@/pages/CountyDetail";
import PlaceDetail from "@/pages/PlaceDetail";
import AdminBPS from "@/pages/AdminBPS";
import AdminCustomers from "@/pages/AdminCustomers";
import AdminCustomerDetail from "@/pages/AdminCustomerDetail";
import HotMarkets from "@/pages/HotMarkets";
import Chat from "@/pages/Chat";
import CitiesAnalytics from "@/pages/CitiesAnalytics";
import Hire from "@/pages/Hire";
import AdminEngagements from "@/pages/AdminEngagements";
import AdminDashboard from "@/pages/AdminDashboard";
import QA from "@/pages/QA";
import Pricing from "@/pages/Pricing";
import Billing from "@/pages/Billing";
import BillingSuccess from "@/pages/BillingSuccess";
import Services from "@/pages/Services";
import AHJVerify from "@/pages/AHJVerify";
import DueDiligence from "@/pages/DueDiligence";
import DataCenter from "@/pages/DataCenter";
import Hotels from "@/pages/Hotels";
import { TrialCountdownBanner, TrialPromoPopup } from "@/components/TrialUpsell";
import { AnnualUpsellModal, useAnnualUpsell } from "@/components/AnnualUpsell";
import InstallAppBanner from "@/components/InstallAppBanner";

function AnnualUpsellMount() {
  const { status, refresh } = useAnnualUpsell();
  return <AnnualUpsellModal status={status} onDismissed={refresh} />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <ErrorBoundary>
            <TrialCountdownBanner />
            <TrialPromoPopup />
            <AnnualUpsellMount />
            <InstallAppBanner />
            <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/hot-markets" element={<HotMarkets />} />
            <Route path="/services" element={<Services />} />
            <Route path="/data-center" element={<DataCenter />} />
            <Route path="/hotels" element={<Hotels />} />
            <Route path="/ahj-verify" element={<AHJVerify />} />
            <Route path="/due-diligence" element={<ProtectedRoute><DueDiligence /></ProtectedRoute>} />
            <Route path="/hire" element={<Hire />} />
            <Route path="/qa" element={<QA />} />
            <Route path="/admin/engagements" element={<ProtectedRoute><AdminEngagements /></ProtectedRoute>} />
            <Route path="/admin/dashboard" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
            <Route
              path="/chat"
              element={
                <ProtectedRoute>
                  <Chat />
                </ProtectedRoute>
              }
            />
            <Route
              path="/cities-insights"
              element={
                <ProtectedRoute>
                  <CitiesAnalytics />
                </ProtectedRoute>
              }
            />
            <Route path="/pricing" element={<Pricing />} />
            <Route
              path="/billing"
              element={
                <ProtectedRoute>
                  <Billing />
                </ProtectedRoute>
              }
            />
            <Route
              path="/billing/success"
              element={
                <ProtectedRoute>
                  <BillingSuccess />
                </ProtectedRoute>
              }
            />
            <Route
              path="/map"
              element={
                <ProtectedRoute>
                  <MapWorkspace />
                </ProtectedRoute>
              }
            />
            <Route
              path="/county/:fips"
              element={
                <ProtectedRoute>
                  <CountyDetail />
                </ProtectedRoute>
              }
            />
            <Route
              path="/place/:geoid"
              element={
                <ProtectedRoute>
                  <PlaceDetail />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/bps"
              element={
                <ProtectedRoute>
                  <AdminBPS />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/customers"
              element={
                <ProtectedRoute>
                  <AdminCustomers />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/customers/:id"
              element={
                <ProtectedRoute>
                  <AdminCustomerDetail />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          </ErrorBoundary>
        </BrowserRouter>
        <Toaster richColors position="top-right" />
      </AuthProvider>
    </div>
  );
}

export default App;
